export enum PositionEnum {
  LEFT_SIDE = 'leftSide',
  RIGHT_SIDE = 'rightSide',
  GENERAL_DAY = 'generalDay',
  GENERAL_NIGHT = 'generalNight',
  SITTING = 'sitting',
  PRONE = 'prone',
  SUPINE = 'supine',
  WHEELCHAIR = 'wheelchair',
}